import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import ReviewCount from '../ReviewCount';
import s from '../ProviderReviewSummary.module.scss';

const dataHooks = {
  averageReviewScore: 'review-score-average',
};
interface IReviewScoreProps {
  isStickyMobileView: boolean;
  isMobileView: boolean;
  reviewsCount: number;
  averageReviewRating: number;
}

const ReviewScore = ({
  isMobileView,
  isStickyMobileView,
  reviewsCount,
  averageReviewRating,
}: IReviewScoreProps) => {
  const {
    i18n: { language },
  } = useTranslation();

  const haveReviews = (reviewsCount ?? 0) > 0;

  if (!haveReviews) {
    return <NoReviewsText />;
  }

  return (
    <Box
      className={
        isStickyMobileView ? s.stickyMobileViewAlignment : s.centerAlign
      }
    >
      <Box dataHook={dataHooks.averageReviewScore} marginRight="3px">
        <Text
          size={isStickyMobileView ? 'tiny' : 'medium'}
          weight="normal"
          dataHook="average-review-rating"
        >
          {Intl.NumberFormat(language, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }).format(averageReviewRating ?? 0)}
        </Text>
      </Box>
      <ReviewCount isMobileView={isMobileView} reviewsCount={reviewsCount} />
    </Box>
  );
};

export default ReviewScore;

const NoReviewsText = () => {
  const { t } = useTranslation();

  return (
    <Box width="max-content" marginLeft="3px" className={s.noReviews}>
      <Text
        size="tiny"
        weight="thin"
        dataHook="no-reviews"
        className={s.noReviewsText}
      >
        {t('profile-no-reviews')}
      </Text>
    </Box>
  );
};
